var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "#E5EDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 17.5V19.5H34.5V17.5H25.5ZM25 15C23.8954 15 23 15.8954 23 17L21 17C19.067 17 17.5 18.567 17.5 20.5V40.5C17.5 42.433 19.067 44 21 44H39C40.933 44 42.5 42.433 42.5 40.5V20.5C42.5 18.567 40.933 17 39 17H37C37 15.8954 36.1046 15 35 15H25ZM37 19.5V20C37 21.1046 36.1046 22 35 22H25C23.8954 22 23 21.1046 23 20V19.5H21C20.4491 19.5 20 19.9491 20 20.5V40.5C20 41.0509 20.4491 41.5 21 41.5H39C39.5509 41.5 40 41.0509 40 40.5V20.5C40 19.9491 39.5509 19.5 39 19.5H37ZM28.5 29.5H25.5V32.5H28.5V35.5H31.5V32.5H34.5V29.5H31.5V26.5H28.5V29.5Z",
    fill: "#2E3438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrData);
export default __webpack_public_path__ + "static/media/EHRData.da0593a2b9052749a5c6f0dcbfde157c.svg";
export { ForwardRef as ReactComponent };